import type { ReactNode } from 'react';

export const symbol_directory_sync: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-480q0-150 105-255t255-105v-50q0-9 8-13.5t16 1.5l128 98q12 9 12 24t-12 24l-128 98q-8 6-16 1.5t-8-13.5v-50q-100 0-170 70t-70 170q0 48 17.5 91.5T306-310q10 11 9.5 25.5T304-262l-36 27q-14 11-30 10t-27-14q-45-50-68-112t-23-129Zm360 360v50q0 9-8 13.5T456-58l-128-98q-12-9-12-24t12-24l128-98q8-6 16-1.5t8 13.5v50q100 0 170-70t70-170q0-48-18-91.5T652-650q-10-11-9-25.5t12-22.5l35-27q13-10 29.5-9t27.5 13q45 49 69 111.5T840-480q0 150-105 255T480-120Z"
		/>
	</svg>
);
